<div style="width: 25px;height: 25px;float: right;position: relative;top: -14px;right: -10px;cursor: pointer;"
     (click)="closeModal()">
    <i class="material-icons icon" style="font-size: 30px;color: #c80000">
        cancel
    </i>
</div>
<mat-dialog-content>
    <form>
        <button type="button" class="btn btn-primary" style="margin-right: 10px;" (click)="requestsApproveSelected()">
            Onayla
        </button>
        <button type="button" class="btn btn-light" (click)="closeModal()">İptal</button>
    </form>
</mat-dialog-content>
